var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccpeted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/cards/status/accpeted"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,6 C10.02975,6 6,10.02975 6,15 C6,19.971 10.02975,24 15,24 C19.97025,24 24,19.971 24,15 C24,10.02975 19.97025,6 15,6 Z M20.022852,13.17075 L14.0465294,19.626 C13.9243228,19.75875 13.7257369,19.75875 13.6042246,19.626 L12.7210037,18.66225 C12.5994914,18.53025 12.4002112,18.31425 12.2793933,18.18075 L10.2240994,15.84675 C10.1636904,15.7815 10.13175,15.68925 10.13175,15.6015 C10.13175,15.51525 10.1636904,15.43125 10.2240994,15.366 L11.1246792,14.48925 C11.1857825,14.42175 11.2670222,14.38875 11.3475675,14.38875 C11.426724,14.3895 11.5058806,14.42325 11.5662896,14.48925 L13.604919,16.7355 C13.7264313,16.869 13.9250171,16.869 14.0472238,16.7355 L18.698715,11.72475 C18.8209217,11.592 19.0188132,11.592 19.1403255,11.72475 L20.0235464,12.6885 C20.1450587,12.8205 20.1450587,13.038 20.022852,13.17075 Z",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccpeted);
export default __webpack_public_path__ + "static/media/accpeted.b738c003.svg";
export { ForwardRef as ReactComponent };